import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type TrigaleUpFillProps = IconComponentBaseProps;

export const TrigaleUpFill = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: TrigaleUpFillProps) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_7733_15999"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_7733_15999)">
        <path
          d="M11.4911 5.25256L8.1485 9.06479C8.10254 9.11742 8.0663 9.17619 8.03978 9.24112C8.01326 9.30585 8 9.37531 8 9.44952C8 9.59773 8.04393 9.72657 8.1318 9.83607C8.21966 9.94536 8.33545 10 8.47918 10H15.5208C15.6645 10 15.7803 9.94475 15.8682 9.83425C15.9561 9.72395 16 9.5952 16 9.44801C16 9.41111 15.9504 9.28337 15.8512 9.06479L12.5089 5.25256C12.4322 5.16484 12.3528 5.10082 12.2708 5.06049C12.1887 5.02016 12.0985 5 12 5C11.9015 5 11.8113 5.02016 11.7292 5.06049C11.6472 5.10082 11.5678 5.16484 11.4911 5.25256Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
